<script lang="ts" setup>
import recipientStarsImage from '@consumer/assets/images/recipient-stars.svg'
</script>

<template>
  <img :src="recipientStarsImage">
</template>
